export default function ({ $axios }) {
  $axios.onError((error) => {
    const method = error.config?.method?.toUpperCase() || 'UNKNOWN'
    const url = error.config?.url || 'unknown URL'
    const status = error.response?.status || 'no response'

    console.error(`Axios error: ${method} ${url} — status ${status}`)
  })
}
